export const SET_ACTIVE_FILTER = 'bikes/SET_ACTIVE_FILTER';

export const SET_VIEW = 'bikes/SET_VIEW';

export const SET_SORT = 'bikes/SET_SORT';

export const SET_RESULTS = 'bikes/SET_RESULTS';

export const LOAD_MORE = 'bikes/LOAD_MORE';

export const SET_FILTER_RANGE = 'bikes/SET_FILTER_RANGE';

export const SET_FILTER_CHOICE = 'bikes/SET_FILTER_CHOICE';

export const TOGGLE_FILTER_MONTHLY = 'bikes/TOGGLE_FILTER_MONTHLY';

export const SET_GENRE = 'bikes/SET_GENRE';

export const SET_FILTER_VALUES = 'bikes/SET_FILTER_VALUES';

export const RESET_FILTER = 'bikes/RESET_FILTER';

export const CLEAR_FILTERS = 'bikes/CLEAR_FILTERS';

export const OPEN_FILTERS_MODAL = 'bikes/OPEN_FILTERS_MODAL';

export const CLOSE_FILTERS_MODAL = 'bikes/CLOSE_FILTERS_MODAL';

export const APPLY_FILTERS = 'bikes/APPLY_FILTERS';

export const SET_FEATURE_CARDS = 'bikes/SET_FEATURE_CARDS';
